/* 布局 */
//前台
import Layout from "@views/layout";

const sectorbehaviorstatsRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "sectorbehaviorstats",
            name: "SECTORBEHAVIORSTATS",
            meta: {
                title: "页面访问统计",
                sort: 1,
            },
            component: () => import("@views/business/sectorbehaviorstats/index.vue"),
            redirect: {
                name: "SECTORBEHAVIORSTATS_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "SECTORBEHAVIORSTATS_LIST",
                    meta: {
                        title: "页面访问统计",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/sectorbehaviorstats/list.vue"),
                },
                                                        ],
    },


        ],
};

export default sectorbehaviorstatsRouter;
